import React from 'react';
interface CharactersListProps {
  characters: string[];
  onCharacterClick: (character: string) => void;
  className?: string;
  itemClassName?: string;
  title?: string;
}
const CharactersList: React.FC<CharactersListProps> = ({
  characters,
  onCharacterClick,
  className = '',
  itemClassName = '',
  title
}) => {
  return (
    <div className={className}>
      {title && (
        <div className="characters-list-title">
          {title}
        </div>
      )}
      <div className="characters-list-container">
        {characters.map((char, index) => (
          <div
            key={`${char}-${index}`}
            className={`character-list-item ${itemClassName}`}
            onClick={() => onCharacterClick(char)}
          >
            {char}
          </div>
        ))}
      </div>
    </div>
  );
};
export default CharactersList; 